var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M16.0768 7.224L17.2768 8.448L13.1968 12.528L17.2528 16.608L16.0528 17.832L11.9488 13.776L7.94081 17.832L6.69281 16.608L10.7488 12.528L6.66881 8.472L7.91681 7.224L11.9728 11.328L16.0768 7.224Z"}})}
var staticRenderFns = []

export { render, staticRenderFns }